import React from 'react';
import HelpPanel from '@cloudscape-design/components/help-panel';
import { ExternalLinkGroup } from './common';

export function NotificationMonitoringHelp() {
  return (
    <HelpPanel
      header={<h2>Notification Monitoring</h2>}
      footer={
        <ExternalLinkGroup
          items={[
            { href: '#', text: 'Notification Workflow Documentation' },
            { href: '#', text: 'Email Tracking Guide' },
            { href: '#', text: 'Escalation Process Overview' }
          ]}
        />
      }
    >
      <p>
        The Notification Monitoring page allows you to track, manage, and take action on notifications sent through the system.
      </p>
      
      <h3>Notification Table</h3>
      <p>
        The main table displays all notifications with key information:
      </p>
      <ul>
        <li><strong>ID</strong>: Unique identifier for the notification</li>
        <li><strong>Event Type</strong>: The type of event that triggered the notification</li>
        <li><strong>Customer</strong>: The customer associated with the notification</li>
        <li><strong>Account Manager</strong>: The recipient of the notification</li>
        <li><strong>Sent Date</strong>: When the notification was sent</li>
        <li><strong>Status</strong>: Current status of the notification</li>
        <li><strong>Email Stats</strong>: Tracking data for email opens and clicks</li>
      </ul>
      
      <h3>Notification Statuses</h3>
      <p>
        Notifications can have the following statuses:
      </p>
      <ul>
        <li><strong>PENDING</strong>: Notification is queued for sending</li>
        <li><strong>SENT</strong>: Notification has been sent but not yet opened</li>
        <li><strong>READ</strong>: Notification email has been opened by the recipient</li>
        <li><strong>ESCALATED</strong>: Notification has been escalated to Slack</li>
      </ul>
      
      <h3>Filtering and Searching</h3>
      <p>
        Use the property filter at the top to search and filter notifications by:
      </p>
      <ul>
        <li>Event Type</li>
        <li>Customer Name</li>
        <li>Status</li>
      </ul>
      
      <h3>Actions</h3>
      <p>
        For each notification, you can:
      </p>
      <ul>
        <li><strong>Resend notification</strong>: Send the notification again</li>
        <li><strong>Mark for escalation</strong>: Manually escalate to Slack</li>
        <li><strong>View details</strong>: See complete notification information</li>
      </ul>
      
      <h3>Bulk Actions</h3>
      <p>
        Select multiple notifications to perform actions in bulk:
      </p>
      <ul>
        <li><strong>Resend selected</strong>: Resend all selected notifications</li>
        <li><strong>Escalate selected</strong>: Escalate all selected notifications to Slack</li>
      </ul>
      
      <h3>Preferences</h3>
      <p>
        Use the preferences menu to customize the table view:
      </p>
      <ul>
        <li>Adjust page size</li>
        <li>Select which columns to display</li>
      </ul>
    </HelpPanel>
  );
}
